export default {
  digitalMarketing: (state) => state.digitalMarketing
};
